module.exports = __webpack_public_path__ + "img/Video_3D_Icon.bb7fdd0e.png";